import {ProductDataFragment} from '../lib/generated';
import {ProductJsonLd} from 'next-seo';

export const ProductData = ({product}: { product: ProductDataFragment }) => {
    return <ProductJsonLd
        productName={product.title}
        description={product.description}
        brand={'Blickfang'}
        images={product.images.edges.map(image => image.node.url)}
        offers={[
            {
                price: product.variants.edges[0].node.priceV2.amount,
                priceCurrency: product.variants.edges[0].node.priceV2.currencyCode,
                url: 'https://blckfng.com/items/' + product.handle,
                itemCondition: 'https://schema.org/NewCondition',
                availability: product.availableForSale ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
            },
        ]}
    />
}
